export default __webpack_public_path__ + "static/media/circle-2.dfe1dac0.png";